import styled from "styled-components";
export const Styles = styled.div`
  .waiting {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
  }
  .waiting .main-container {
    display: block;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 0;
  }
  .waiting .main-container span {
    position: relative;
    top: 45%;
    left: 0%;
  }
  .join-data {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
  .image{
    height: 200px;
    width: 300px;
  }
  .image img{
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
   }
  .title {
    font-size: 22px;
    font-weight: bold;
    color: var(--dark-purple);
    border-bottom: 2px solid var(--dark-purple);
    margin-bottom: 10px;
  }
  .join-button {
    margin-top: 20px;
    border-radius: 7px;
  }
  .join-button .btn {
    width: 250px !important;
    height: 50px !important;
    padding: 20px !important;
    box-shadow: -2px 5px 10px #46454774 !important;
  }
  .join-button .btn .btn-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 17px;
  }
  .note {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    text-align: center;
  }
  @media (max-width: 768px) {
    .note {
      font-size: 13px;
    }
  }
`;
